// IfNode.js
import React from 'react';
import { Handle, Position } from 'reactflow';
// import ifIcon from './ifIcon.svg'; // Optional: if you have an icon for IF node

const IfNode = ({ data }) => {
  return (
    <div
      style={{
        padding: '10px',
        border: '5px solid #ddd',
        borderRadius: '25px',
        backgroundColor: '#fff',
        width: '105px',
        height: '105px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        flexDirection: 'column',
      }}
    >
      {/* Optional Icon */}
      {/* <img src={ifIcon} alt="IF" style={{ width: '50%', height: '50%' }} /> */}
      <div style={{ fontSize: '24px', fontWeight: 'bold' }}>IF</div>
      <Handle
        type="target"
        position={Position.Left}
        style={{ top: '50%', transform: 'translateY(-50%)', borderRadius: 0 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="true"
        style={{ top: '35%', borderRadius: 0 }}
      />
      <Handle
        type="source"
        position={Position.Right}
        id="false"
        style={{ top: '65%', borderRadius: 0 }}
      />
      <div
        style={{
          position: 'absolute',
          top: '32%',
          right: '-50px',
          width: '40px',
          textAlign: 'center',
          fontSize: '12px',
        }}
      >
        True
      </div>
      <div
        style={{
          position: 'absolute',
          top: '62%',
          right: '-50px',
          width: '40px',
          textAlign: 'center',
          fontSize: '12px',
        }}
      >
        False
      </div>
    </div>
  );
};

export default IfNode;
